export function random (min, max) {
  const rand = Math.random()

  if (typeof min === 'undefined') {
    return rand
  } else if (typeof max === 'undefined') {
    if (min instanceof Array) {
      return min[Math.floor(rand * min.length)]
    } else {
      return rand * min
    }
  } else {
    if (min > max) {
      var tmp = min
      min = max
      max = tmp
    }

    return rand * (max - min) + min
  }
}

export function rectangleOverlap(r1, r2) {
  // The rectangles don't overlap if
  // one rectangle's minimum in some dimension
  // is greater than the other's maximum in
  // that dimension.
  const noOverlap =
    r1.x > r2.x + r2.width ||
    r2.x > r1.x + r1.width ||
    r1.y > r2.y + r2.height ||
    r2.y > r1.y + r1.height

  return !noOverlap
}

export function clamp (num, min, max) {
  return num <= min ? min : num >= max ? max : num
}
